// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"47fbfc4d","66":"9ae7d5ec","626":"4c68a991","667":"635f34aa","739":"94ade9a8"}[chunkId] + ".chunk.js";
};